<template>
  <div class="login">
    <div class="banner">
      <img src="../assets/images/login_banner.png" alt="" />
    </div>

    <div class="form_data">
      <div class="tit">用户登录</div>
    </div>

    <!-- 微信注册 -->
    <div class="wx_register flex-rowc" @click="checkToken">
      <div class="icon">
        <van-image
          width="100%"
          height="100%"
          :src="require('../assets/images/qw_logo.png')"
        />
      </div>
      企业微信一键授权注册/登录
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getUserInfo } from "../api/api";
import { getQyLogin, checkToken } from "../api/qyChat";
export default {
  name: "qyLogin",
  data() {
    return {};
  },
  computed: {
    ...mapState(["userAgent"]),
  },
  created() {
    // 环境判断
    this.isAgent();
  },
  methods: {
    isAgent() {
      if (/wxwork/.test(navigator.userAgent.toLowerCase())) {
        // 在企业微信中打开
        let { id, token } = this.$route.params;
        if (id != '${userid}' && token != "${token}") {
          this.$store.commit("setQyUserId", id);
        } else {
          // 维应企业
          // 开发：http://api.winksshowp.com/service/qywx/login.aspx?appid=3
          // 产线：https://api.winksshowp.com/service/qywx/login.aspx?appid=2003
          // 月峰：http://adminstage.thinksway.cn/service/qywx/login.aspx?appid=3001
          // 月峰（旧版）：http://spr.ky51.cn/service/qywx/login.aspx?appid=3001

          window.location.replace(
            "http://api.winksshowp.com/service/qywx/login.aspx?appid=3"
          );
        }
      } else {
        // 非企业微信环境中打开
        // this.$store.commit("setQyUserId", 'superjingjing');
        this.$store.commit("setQyUserId", 1);
      }
    },

    // token 验证
    checkToken() {
      let { id, token } = this.$route.params;
      checkToken({ userid: id, token }).then((res) => {
        if (res.result) {
          this.handleQyLogin();
        } else {
          this.$toast.fail(res.message || "网络请求错误，请稍后～");
        }
      });
    },

    // 一键授权登录
    handleQyLogin() {
      // let qywx_userid = "superjingjing";
      let { id } = this.$route.params;
      const toast = this.$toast.loading({
        message: "登录中...",
        forbidClick: true,
      });
      getQyLogin({ qywx_userid: id }).then((res) => {
        toast.clear();
        if (res.result) {
          this.$toast.success(res.message);
          this.$store.commit("updateOpenid", res.code);
          this.getUserInfo(res.code);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 获取用户信息
    getUserInfo(openid) {
      getUserInfo({ openid: openid }).then((res) => {
        if (Object.keys(res).length > 0) {
          this.$store.commit("updateUserInfo", res);
          if (res.mobile) {
            setTimeout(() => {
              this.$store.commit("setUserLoginType", 1);
              this.$router.push("/home");
            }, 1500);
          } else {
            setTimeout(() => {
              this.$router.push("/guide");
            }, 1500);
          }
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
.form_data {
  padding: 88px 70px 0;
  font-size: 30px;
  .tit {
    text-align: center;
    color: #444444;
    margin-bottom: 75px;
  }
  .radio_group {
    margin: 68px auto 110px;
  }
  .input_box {
    margin-bottom: 60px;
    input {
      text-align: center;
    }
    .visual {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
      .iconfont {
        font-size: 38px;
        color: #818181;
      }
    }
  }
  // .verify-wrap {
  //   width: 500px;
  //   margin: 0 auto 90px;
  //   font-size: 20px;
  // }

  .register {
    text-align: center;
    margin-top: 73px;
    font-size: 26px;
    p {
      width: 200px;
      color: #464646;
      font-size: 24px;
      margin: 0 auto 55px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.register_popup {
  width: 500px;
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  .img {
    width: 440px;
    height: 440px;
  }
  .txt {
    margin-top: 40px;
    font-size: 28px;
    text-align: center;
  }
}
.van-popup {
  z-index: 100001 !important;
}

.verify-wrap {
  width: 500px;
  font-size: 20px;
}
.popup_box {
  height: 100vh;
  top: 0;
  position: fixed;
  z-index: 999999999999;
  width: 100%;
  .popup_wrapper {
    width: 550px;
    box-sizing: border-box;
    background: #fff;
    top: 34%;
    margin: auto;
    position: relative;
    z-index: 9999999999;
    .popup_header {
      height: 110px;
      padding: 0 20px;
      font-size: 32px;
      box-sizing: border-box;
    }
    .popup_content {
      padding: 25px 0 70px;
      position: relative;
    }
  }
}
.wx_register {
  font-size: 28px;
  color: #333333;
  width: 600px;
  height: 110px;
  border: 1px solid #aaaaaa;
  margin: 50px auto 0;
  .icon {
    width: 43px;
    height: 35px;
    margin-right: 28px;
  }
}
</style>